import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  card: {
    width: '100%'
  },
  title: {
    fontSize: 18,
    fontWeight: 600
  },
  chipContainer: {
    display: 'flex',
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 5
    }
  },
  hasChip: {
    display: 'flex',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 5
    }
  },
  chipBox: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    backgroundColor: GRAY_COLORS[100],
    border: `1px solid ${GRAY_COLORS[200]}`,
    padding: '2px 8px',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: 'fit-content'
    }
  },
  childChipBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: `1px solid ${GRAY_COLORS[50]}`,
    padding: '0 8px',
    borderRadius: 16,
    maxWidth: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap'
  },
  childChipText: {
    color: INFO_COLORS[700],
    fontSize: 12
  },
  chipTitle: {
    fontSize: 12,
    fontWeight: 500
  },
  cardContent: {
    '&:last-child': {
      paddingBottom: 16
    }
  },
  boxItem: {
    display: 'flex',
    paddingTop: 8,
    paddingBottom: 8,
    maxWidth: 220
  },
  description: {
    fontWeight: 600,
    fontSize: 14
  },
  divider: {
    paddingTop: 16,
    paddingBottom: 16
  }
}))
